import { useState, useCallback } from 'react'
import { useGenotypingExport } from './useExport'

export interface FilteredData {
  filterValue: string
  filteredList: any[]
}

export const useGenotypingFilteredExport = (allData: any[]) => {
  const [filteredData, setFilteredData] = useState<FilteredData | null>(null)
  const { exportData: exportWithConfig } = useGenotypingExport()

  const handleFilteredDataChange = useCallback((data: FilteredData) => {
    setFilteredData(data)
  }, [])

  const exportData = useCallback(() => {
    // Se há filtro aplicado, exporta os dados filtrados
    // Senão, exporta todos os dados
    const dataToExport = filteredData?.filterValue ? filteredData.filteredList : allData

    if (dataToExport?.length) {
      exportWithConfig(dataToExport)
    } else {
      console.warn('Nenhum dado para exportar')
    }
  }, [filteredData, allData, exportWithConfig])

  const getExportInfo = useCallback(() => {
    const isFiltered = !!filteredData?.filterValue
    const totalItems = isFiltered ? filteredData?.filteredList.length : allData?.length

    return {
      isFiltered,
      totalItems,
      filterValue: filteredData?.filterValue || ''
    }
  }, [filteredData, allData])

  return {
    exportData,
    handleFilteredDataChange,
    getExportInfo
  }
}
